module.exports = __webpack_public_path__ + "static/media/carousel10.76c2ef9a.jpeg";